import { KendoBaseComponent } from '@progress/kendo-base-components-vue-wrapper'
import ButtonProps from './ButtonProps'

export default {
    props: ButtonProps,
    emits: {
        'kendowidgetready': null
    },
    mixins: [
        KendoBaseComponent
    ],
    mounted() {
        kendo.jQuery(this.$el).kendoButton(this.widgetOptions)

        if(this.v3) {
            this.ready()
            this.$emit('kendowidgetready', this.kendoWidget())
        } else {
            this.$emit('kendowidgetready', this.kendoWidget())
        }
    },
    methods: {
        kendoWidget() {
            return kendo.jQuery(this.$el).getKendoButton()
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-buttons-vue-wrapper/src/KendoButton/KendoButtonMixin.js